import {useResetAtom} from 'jotai/utils';
import React, {useCallback} from 'react';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {
  AuthWorkflow,
  AuthWorkflowFooter,
  PasswordReset,
  Signin,
} from 'webapp-lib/DesignComponents';
import {LoginSessionType} from 'webapp-lib/typings';

import {userState} from '_/state/user';

export const PWReset = ({
  loginHeader,
}: {
  loginHeader: React.ReactElement;
}): React.ReactElement => {
  const {t} = useTranslation('common');
  const navigate = useNavigate();

  const abortPWReset = useCallback(() => {
    navigate('/login/');
  }, [navigate]);

  return (
    <>
      <Helmet>
        <title>{t('login.titles.pwReset')}</title>
      </Helmet>
      <AuthWorkflow
        Header={t('login.titles.pwReset')}
        MainComponent={
          <PasswordReset
            onAbort={abortPWReset}
            onSuccess={() => navigate('/login/')}
          />
        }
        OuterHeader={loginHeader}
      />
    </>
  );
};

export const Login = ({
  loginHeader,
  VersionInfo,
}: {
  loginHeader: React.ReactElement;
  VersionInfo: React.ReactElement;
}): React.ReactElement => {
  const {t} = useTranslation('common');
  const resetUserState = useResetAtom(userState);
  const navigate = useNavigate();

  const navigateOnLogin = useCallback(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const redirect = urlParams.get('redirect');

    navigate(redirect || '/', {replace: true});
  }, [navigate]);

  return (
    <>
      <Helmet>
        <title>{t('login.titles.login')}</title>
      </Helmet>
      {VersionInfo}
      <AuthWorkflow
        Header={t('login.titles.login')}
        MainComponent={
          <Signin
            baseURL={process.env.REACT_APP_SERVER_URL}
            sessionType={LoginSessionType.BROWSER}
            onLoad={resetUserState}
            onSuccess={navigateOnLogin}
          />
        }
        OuterFooter={<AuthWorkflowFooter />}
        OuterHeader={loginHeader}
      />
    </>
  );
};
